// extracted by mini-css-extract-plugin
export default {"Icon":"WhatsappButton_Icon__DbSYE"};